export default import.meta.ROLLDOWN_FILE_URL_OHh_BaZAOYh9kalPDhLCJw